"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get EncounterSignRequestSchema () {
        return EncounterSignRequestSchema;
    },
    get EncounterSignResponseSchema () {
        return EncounterSignResponseSchema;
    }
});
const _zod = require("zod");
const _encounterlabresults = require("./encounter-lab-results");
const EncounterSignRequestSchema = _zod.z.object({
    soapVersion: _zod.z.number({
        message: 'soapVersion must be a number.'
    }).int({
        message: 'soapVersion must be a whole number.'
    }).min(0, {
        message: 'soapVersion must not be negative.'
    }),
    labResultIds: (0, _encounterlabresults.encounterLabResultIds)()
}).strict();
const EncounterSignResponseSchema = _zod.z.object({
    id: _zod.z.string().uuid(),
    status: _zod.z.literal('signed'),
    signedAt: _zod.z.string().datetime({
        offset: true
    })
}).strict();
